import React from 'react';
import {Button, BUTTON_COLOR, BUTTON_STYLE} from '../../../../components/new-ui/ButtonV2';

export const ActionsColumn = ({actionText}) => {
	return <Button buttonColor={BUTTON_COLOR.TEXT_PURPLE} buttonStyle={BUTTON_STYLE.TEXT} content={actionText || 'See more'} />;
};
